import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { shouldHideWorkflowList } from './workflow-app-routes';
import WorkflowListPage from './workflow-list-page';

export default function WorkflowPage() {
  const location = useLocation();
  const hideList = shouldHideWorkflowList(location.pathname);

  return (
    <>
      {!hideList && <WorkflowListPage />}
      <Outlet />
    </>
  );
}
